import { audio } from '@/audio-singleton';
import { useEffect, useState } from 'preact/hooks';
import { msUntilNextPuzzleBudapest } from '@/lib/timezone';
import { t } from '@/i18n';

const ROLLED_THRESHOLD_MS = 22 * 3_600_000;

function compute(): { ms: number; rolled: boolean } {
  const ms = msUntilNextPuzzleBudapest(new Date());
  return { ms, rolled: ms > ROLLED_THRESHOLD_MS };
}

export function CountdownCard() {
  const [{ ms, rolled }, setState] = useState(compute());

  useEffect(() => {
    const tick = () => setState(compute());
    const id = window.setInterval(tick, 1000);
    const onShow = (e: PageTransitionEvent) => { if (e.persisted) tick(); };
    window.addEventListener('pageshow', onShow as EventListener);
    return () => {
      window.clearInterval(id);
      window.removeEventListener('pageshow', onShow as EventListener);
    };
  }, []);

  if (rolled) {
    return (
      <section class="mx-auto mt-5 max-w-[22rem] px-4 text-center">
        <p class="font-mono text-[10px] uppercase tracking-[0.22em] text-streak mb-3">
          {t('countdown.newPuzzleAvailable')}
        </p>
        <button
          class="font-mono text-xs uppercase tracking-[0.18em] px-5 py-2.5 rounded-md bg-streak text-bg hover:bg-foil-bright active:scale-95 transition-all"
          onClick={() => { audio().play('tap'); window.location.reload(); }}
        >{t('countdown.reload')}</button>
      </section>
    );
  }
  const total = Math.max(0, ms);
  const hours = Math.floor(total / 3_600_000);
  const minutes = Math.floor((total % 3_600_000) / 60_000);
  return (
    <section class="mx-auto mt-5 max-w-[22rem] px-4 text-center">
      <p
        data-testid="countdown-text"
        class="font-mono text-[10px] uppercase tracking-[0.22em] text-text-dim"
      >{t('countdown.nextPuzzle', { hours, minutes })}</p>
    </section>
  );
}
